import React, { useState } from "react"
import PropTypes from "prop-types"
import BroadcastListItem from "containers/BroadcastListItem/BroadcastListItem"
import styles from "./broadcastListStyle.css"

const BroadcastList = ({ broadcasts, type, onClick }) => {
  const [displayAll, setDisplayAll] = useState(false)

  const defaultShownNumber = 4
  const hasMore = broadcasts.length > defaultShownNumber
  const limit = displayAll ? broadcasts.length : defaultShownNumber

  const handleDisplayAll = () => {
    setDisplayAll(true)
  }

  return (
    <section className={styles.root}>
      <ul className={styles.broadcastList}>
        {broadcasts.slice(0, limit).map(broadcast => (
          <li key={broadcast.getId()} className={styles.broadcastListItemDelimiter}>
            <BroadcastListItem broadcast={broadcast} type={type} onClick={onClick} />
          </li>
        ))}
      </ul>
      {hasMore && !displayAll && (
        <div className={styles.broadcastListItemShowMoreContainer}>
          <button
            type="button"
            className={styles.broadcastListItemShowMoreBtn}
            onClick={handleDisplayAll}
            aria-label="Montrer plus de programmes"
            title="Montrer plus de programmes"
          >
            Voir plus
          </button>
        </div>
      )}
    </section>
  )
}

BroadcastList.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["play", "record"]).isRequired,
  broadcasts: PropTypes.arrayOf(
    PropTypes.shape({
      getStartAt: PropTypes.func.isRequired,
      channel: PropTypes.shape({
        data: PropTypes.shape({
          image_bundle: PropTypes.shape({
            logo_player: PropTypes.shape({
              small: PropTypes.shape({
                url: PropTypes.string.isRequired,
              }).isRequired,
            }).isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

BroadcastList.defaultProps = {
  broadcasts: [],
}

export default BroadcastList
